module.exports = __webpack_public_path__ + "images/avatar-yxshawn-0b45d1cf312e8b66c2ba46a5c32a7418.png";